import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ViewEndpointsComponent} from './view-endpoints.component';
import {SidenavHeaderModule} from '../../../components/sidenav-header/sidenav-header.module';
import {SharedModule} from '../../../shared/shared.module';
import {IconsModule} from '../../../icons/icons.module';
import {EndpointRowComponent} from './endpoint-row/endpoint-row.component';
import {ClipboardModule} from '@angular/cdk/clipboard';


@NgModule({
  declarations: [
    ViewEndpointsComponent,
    EndpointRowComponent
  ],
  exports: [
    ViewEndpointsComponent,
    EndpointRowComponent
  ],
  imports: [
    CommonModule,
    SidenavHeaderModule,
    SharedModule,
    IconsModule,
    ClipboardModule,
  ]
})
export class ViewEndpointsModule {
}
